import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            听听影迷们怎么说春色影视
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {commentsData.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                />
                <div>
                  <p className="text-foreground-900 text-sm font-semibold">{comment.name}</p>
                  <p className="text-foreground-400 text-xs">{comment.time}</p>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed flex-1">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center gap-1 mt-4 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}